// analytics/PostHogProvider.ts
import { capturePostHog } from './posthogClient';
import { AnalyticsProvider } from './AnalyticTypes';

// posthog-js is lazy-loaded and initialized once, in posthogClient.ts; events
// sent before it loads are queued there.
export class PostHogAnalyticsProvider implements AnalyticsProvider {
  trackEvent(eventName: string, properties?: Record<string, any>) {
    capturePostHog(eventName, properties);
  }
}
